const common = require('./checklist_items_common')
const getSpotlight = require('module/user/helpers/get_spotlight')
const isAllowedSpotlight = require('module/user/helpers/is_allowed_spotlight')
const log = require('log').create('get started', 'free') // eslint-disable-line

/**
 * checklist items for free users
 *
 * the order here determines the priority of each item, which comes into play
 * when evaluating what their 'next' step is
 *
 * the display order is controlled by the html markup in
 * checklist_view_free.html
 */

const free_checklist_items = [

    {
        id: 'update_disallowed_spotlight',
        applicable() {
            const spotlight = getSpotlight(this.user.toJSON())
            if (! spotlight) return false
            return ! isAllowedSpotlight(this.user.toJSON(), spotlight)
        },
        completed() {
            const spotlight = getSpotlight(this.user.toJSON())
            if (! spotlight) return false
            return isAllowedSpotlight(this.user.toJSON(), spotlight)
        },
    },

    {
        id: 'add_photo',
        applicable() {
            return ! this.user.hasFeature('image')
        },
        completed() {
            return this.user.hasFeature('image')
        },
        onClick(e) {
            e.preventDefault()
            this.showSection('photo')
        },
    },

    {
        id: 'add_email_signature',
        completed() {
            return this.user.hasAction('clicked_signature_cta')
        },
        onClick(e) {
            e.preventDefault()
            this.showSection('emailsignature')
        },
    },

    common.verify_email,

    {
        id: 'add_bio',
        completed() {
            return (
                this.user.hasAction('viewed_bio_pane')
                && this.user.hasFeature('bio')
            )
        },
        onClick(e) {
            e.preventDefault()
            this.showSection('bio')
        },
    },

    common.link_social_sites,

    common.add_custom_domain,

    common.add_testimonials_or_contact_me,

    common.add_portfolio_or_video,

    {
        id: 'capture_leads',
        completed() {
            const spotlight = getSpotlight(this.user.toJSON())
            if (! spotlight) return false
            return spotlight.mechanism === 'capture'
        },
        onClick(e) {
            e.preventDefault()
            this.showSection('setup_capture_spotlight')
        },
    },
    {
        id: 'appointment_scheduling',
        completed() {
            const spotlight = getSpotlight(this.user.toJSON())
            if (! spotlight) return false
            return spotlight.mechanism === 'schedule'
        },
        onClick(e) {
            e.preventDefault()
            this.showSection('setup_schedule_spotlight')
        },
    },
]

module.exports = free_checklist_items
